// STORE
export const NAMESPACE = 'ddv'

// VARIABLES
export const VIDEO_TITLE = 'videoTitle'
export const VIDEO_PRESETS = 'videoPresets'
export const VIDEO_WIDTH = 'videoWidth'
export const VIDEO_HEIGHT = 'videoHeight'
export const FPS_PRESETS = 'fpsPresets'
export const FPS = 'fps'
export const EXPORT_PRESETS = 'exportPresets'
export const FILE_FORMAT = 'fileFormat'
export const HD = 'hd'
export const CODEC = 'codec'
export const SEND_TO_IRIS = 'sendToIris'

// INPUT TYPES
export const TEXT = 'text'
export const NUMBER = 'number'
export const SELECT = 'select'
export const CHECKBOX = 'checkbox'
export const TEXTAREA = 'textarea'
export const URL = 'url'
export const GEOCODE = 'geocode'
export const HIDDEN = 'hidden'

// GENERAL OPTIONS
export const GENERAL_MODEL = [
  {
    type: TEXT,
    name: VIDEO_TITLE,
    label: 'Filename',
    i18nkey: 'filename',
    value: ''
  },
  {
    type: SELECT,
    name: EXPORT_PRESETS,
    label: 'Exporter en',
    i18nkey: 'codec',
    value: ['AVC-Intra — mxf', 'H.264 — mp4', 'ProRes — mov'],
    separator: ' — ',
    displayDependenciesWhen: 'AVC-Intra — mxf',
    dependenciesOrder: [SEND_TO_IRIS]
  },
  {
    type: SELECT,
    name: SEND_TO_IRIS,
    label: 'Envoyer vers IRIS',
    i18nkey: 'sendToIris',
    value: ['Non', 'Oui', 'Vers Validation'],
    valuei18nkeys: ['no', 'yes', 'irisValidation'],
    valuesAssociated: ['none', 'production', 'validation'],
    dependsOn: EXPORT_PRESETS,
    replacesDependentValue: false
  },
  {
    type: SELECT,
    name: VIDEO_PRESETS,
    label: 'Dimensions',
    i18nkey: 'resolution',
    value: ['1920 x 1080', '1280 x 720', '1920 x 1920', 'custom'],
    separator: ' x ',
    displayDependenciesWhen: 'custom',
    dependenciesOrder: [VIDEO_WIDTH, VIDEO_HEIGHT]
  },
  {
    type: NUMBER,
    name: VIDEO_WIDTH,
    label: 'Largeur',
    i18nkey: 'custom.width',
    value: 1920,
    dependsOn: VIDEO_PRESETS,
    replacesDependentValue: true
  },
  {
    type: NUMBER,
    name: VIDEO_HEIGHT,
    label: 'Hauteur',
    i18nkey: 'custom.height',
    value: 1080,
    dependsOn: VIDEO_PRESETS,
    replacesDependentValue: true
  },
  {
    type: SELECT,
    name: FPS_PRESETS,
    label: 'Images par secondes',
    i18nkey: 'fps',
    value: ['50', '25'],
    displayDependenciesWhen: 'custom',
    dependenciesOrder: [FPS]
  },
  {
    type: NUMBER,
    name: FPS,
    label: 'IPS custom',
    i18nkey: 'custom.fps',
    value: 50,
    dependsOn: FPS_PRESETS,
    replacesDependentValue: true
  }
  // {
  //   type: SELECT,
  //   name: FILE_FORMAT,
  //   label: 'Format de fichier',
  //   i18nkey: 'custom.format',
  //   value: ['mov', 'mxf', 'mp4'],
  //   dependsOn: EXPORT_PRESETS
  // },
  // {
  //   type: SELECT,
  //   name: CODEC,
  //   label: 'Codec vidéo',
  //   i18nkey: 'custom.codec',
  //   value: ['ProRes', 'AVC-Intra', 'H.264'],
  //   dependsOn: EXPORT_PRESETS
  // }
  // {type: CHECKBOX, name: HD, label: 'Haute défition', value: false}
]
